<template>
    <div>
        <v-select v-model="jobsite" ref="jobsiteSelect" label="JobsiteName" :filterable="false" @search="onSearch" @input="onChange" :options="options" placeholder="Search Jobsites" :class="{'filter-select': forFilters, 'is-invalid': hasError}">
            <template slot="no-options">
                Search for a Jobsite by Name or Number...
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.JobsiteNumber }} - {{ option.JobsiteName }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" v-if="option.JobsiteName">
                    {{ option.JobsiteNumber }} - {{ option.JobsiteName }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    props: {
        selectedValues: {
            type: Object,
            default: null
        },

        forFilters: {
            type: Boolean,
            default: false,
        },

        excludeId: {
            type: Number,
        },

        hasError: {
            type: Boolean,
            default: false,
        },

        filters: {
            type: Object,
            default: null
        },
    },

    data: function() {
        return {
            options: [],
            jobsite: null,
        }
    },

    watch: {
        //Watcher for errors
        hasError(newValue, oldValue){
            //Set it
            this.hasError = newValue;
        },

        selectedValues(newValue, oldValue){
            if(newValue != null && Object.keys(newValue).length > 0 && !this.jobsite)
            {
                this.options.push(newValue);
                this.jobsite = newValue;
            }
        }
    },

    methods: {
        //Search
        onSearch: function(searchTerm, searchLoading) {
            //Done loading
            searchLoading(true);

            //Send it
            this.$http.get('/jobsites/search', {
                    term: searchTerm,
                    excludeId: this.excludeId,
                    filters: this.filters
                })
                .then(res => {
                    //Set the data
                    this.options = res.data;

                    //Done loading
                    searchLoading(false);
                });
        },

        onChange: function(jobsite){
            //Make sure we're not loading
            if (!this.loading)
            {
                //Send it
                this.$emit('vselected', jobsite);
            }
        },

        setValue(jobsite){
            this.options.push(jobsite);
            this.jobsite = jobsite;
        },

        clearInput(){
            //Reset All
            this.jobsite = null;
            this.options = [];
            this.$refs.jobsiteSelect.clearSelection();
        }

    },

    mounted() {
        //Check for null and empty values
        if (this.selectedValues == null || (Object.keys(this.selectedValues).length === 0 && this.selectedValues.constructor === Object))
        {
            this.jobsite = null;
        }
        else
        {
            this.setValue(this.selectedValues);
        }
    }
}
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 250px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }
</style>
